import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Ritmos Latinos en Gimnasio',
  quote: 'Compré un domingo a la noche. El lunes entré al gimnasio con el plan exacto de la clase. Las progresiones del Tomo 2 son exactamente lo que necesitaba para mis grupos de distintos niveles. Nunca más improviso.'
}, {
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Ritmos Latinos en Academia de Baile',
  quote: 'El Tomo 5, el de Planificación Anual, me cambió todo. Ahora tengo los 12 meses organizados y mis alumnos ven una progresión real. La retención mejoró muchísimo.'
}, {
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Ritmos Latinos Grupal e Individual',
  quote: 'El sistema de clases del Tomo 4 es único en el mercado. Las secuencias de reggaeton están descriptas paso a paso. Antes tardaba horas armando una clase. Ahora abro el PDF y en 5 minutos tengo todo listo.'
}, {
  name: 'Luciana P.',
  location: 'Tucumán',
  role: 'Profe Particular y en Academia de Ritmos',
  quote: 'La Guía de Evaluación del Bono 2 eliminó el problema del grupo heterogéneo. Ahora cada alumno sabe exactamente en qué nivel está y qué necesita para subir. Los avanzados se sienten desafiados y los principiantes se sienten seguros.'
}, {
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'Profe de Ritmos Latinos Online y Presencial',
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de planificación mensual del Tomo 5 y la variedad de los 6 tomos. Los alumnos ahora quieren venir porque siempre hay algo nuevo.'
}, {
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'Profe de Ritmos Latinos en Estudio Propio',
  quote: 'El Banco de Combinaciones del Bono 1 me salvó. Ahora tengo ideas para 3 meses de clases distintas sin repetir. Mis alumnos no pueden creer la variedad que tenemos clase a clase.'
}, {
  name: 'Ana R.',
  location: 'Salta',
  role: 'Profe de Ritmos Latinos en Academia Independiente',
  quote: 'El Ritmos Pro Avanzado me cambió la cabeza. Nunca había dimensionado todo lo que me faltaba para profesionalizar mis clases y empezar a cobrar lo que realmente merezco.'
}];
export function ExtendedTestimonials() {
  return <section className="py-12 md:py-24 bg-neutral-950" data-id="element-87">
      <div className="container mx-auto px-4" data-id="element-88">
        <div className="text-center mb-6 md:mb-16" data-id="element-89">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-90">
            Lo que dicen los profes que ya lo usan:
          </h2>
          <p className="text-sm md:text-xl text-amber-500 font-medium" data-id="element-91">
            +500 profes de ritmos latinos de todo el país ya tienen su RITMOS
            LATINOS RESUELTO
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-4xl md:max-w-7xl mx-auto" data-id="element-92">
          {testimonials.map((t, i) => <div key={i} className="bg-neutral-900 border border-neutral-800 rounded-xl p-3 md:p-8 relative flex flex-col" data-id="element-93">
              <Quote className="absolute top-3 right-3 w-5 h-5 md:w-6 md:h-6 text-neutral-800" data-id="element-94" />
              <div className="flex gap-0.5 mb-2 md:mb-4" data-id="element-95">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 md:w-4 md:h-4 text-amber-500 fill-amber-500" data-id="element-96" />)}
              </div>
              <p className="text-neutral-300 text-xs md:text-sm leading-snug md:leading-relaxed italic mb-3 md:mb-6 flex-grow" data-id="element-97">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-2 md:pt-4 border-t border-neutral-800" data-id="element-98">
                <div className="font-bold text-white text-sm" data-id="element-99">{t.name}</div>
                <div className="text-amber-500 text-[10px] md:text-xs font-medium" data-id="element-100">
                  {t.location} —{' '}
                  <span className="text-neutral-500" data-id="element-101">{t.role}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}